class FullWidthVideo extends HTMLElement {
  connectedCallback() {
    this.poster = this.querySelector('.full-width-video__poster');
    this.media = this.querySelector('.full-width-video__media');
    this.videoDesktop = this.querySelector('.full-width-video__video--desktop');
    this.videoMobile = this.querySelector('.full-width-video__video--mobile');
    this.muteBtn = this.querySelector('.full-width-video__ctrl--mute');
    this.playBtn = this.querySelector('.full-width-video__ctrl--play');
    this.mql = window.matchMedia('(max-width: 575px)');
    this.inView = false;
    this.isMuted = true;
    this.isPlaying = false;
    this.userPaused = false;

    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.mql.addEventListener('change', this.onBreakpointChange);

    if (this.muteBtn) {
      this.muteBtn.addEventListener('click', () => this.toggleMute());
    }

    if (this.playBtn) {
      this.playBtn.addEventListener('click', () => this.togglePlay());
    }

    const onEnded = () => {
      this.userPaused = false;
      this.setPlaying(false);
      this.setMuted(true);
      this.showPoster();
    };
    if (this.videoDesktop) this.videoDesktop.addEventListener('ended', onEnded);
    if (this.videoMobile) this.videoMobile.addEventListener('ended', onEnded);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            if (!this.userPaused) this.playCurrentVideo();
          } else {
            this.pauseAllVideos();
            if (!this.userPaused) this.setMuted(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.media) this.observer.observe(this.media);
  }

  disconnectedCallback() {
    this.mql.removeEventListener('change', this.onBreakpointChange);
    if (this.observer) this.observer.disconnect();
  }

  getActiveVideo() {
    return this.mql.matches ? this.videoMobile : this.videoDesktop;
  }

  getInactiveVideo() {
    return this.mql.matches ? this.videoDesktop : this.videoMobile;
  }

  playCurrentVideo() {
    const active = this.getActiveVideo();
    const inactive = this.getInactiveVideo();

    if (inactive) inactive.pause();
    if (!active) return;

    active.muted = this.isMuted;

    active.play().then(() => {
      this.hidePoster();
      this.setPlaying(true);
    }).catch(() => {});
  }

  pauseAllVideos() {
    if (this.videoDesktop) this.videoDesktop.pause();
    if (this.videoMobile) this.videoMobile.pause();
    this.setPlaying(false);
    this.showPoster();
  }

  hidePoster() {
    if (this.poster) {
      this.poster.classList.add('full-width-video__poster--hidden');
    }
  }

  showPoster() {
    if (this.poster) {
      this.poster.classList.remove('full-width-video__poster--hidden');
    }
  }

  setPlaying(playing) {
    this.isPlaying = playing;
    if (this.playBtn) {
      this.playBtn.classList.toggle('full-width-video__ctrl--playing', playing);
      this.playBtn.classList.toggle('full-width-video__ctrl--active', playing);
    }
  }

  setMuted(muted) {
    this.isMuted = muted;
    const active = this.getActiveVideo();
    if (active) active.muted = muted;

    if (this.muteBtn) {
      this.muteBtn.classList.toggle('full-width-video__ctrl--unmuted', !muted);
      this.muteBtn.classList.toggle('full-width-video__ctrl--active', !muted);
    }
  }

  toggleMute() {
    this.setMuted(!this.isMuted);
  }

  togglePlay() {
    if (this.isPlaying) {
      this.userPaused = true;
      this.pauseAllVideos();
    } else {
      this.userPaused = false;
      this.playCurrentVideo();
    }
  }

  onBreakpointChange() {
    const active = this.getActiveVideo();
    const inactive = this.getInactiveVideo();

    if (inactive) inactive.pause();

    if (this.inView && active) {
      active.muted = this.isMuted;
      active.play().then(() => {
        this.hidePoster();
        this.setPlaying(true);
      }).catch(() => {});
    }
  }
}

customElements.define('full-width-video', FullWidthVideo);
